export function rectsOverlap(a, b) {
    return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
}

function hasCollision(rects, rect) {
    return rects.some((r) => rectsOverlap(rect, r));
}

export function compactWidgets(widgets, cols) {
    const sorted = [...widgets].sort((a, b) => (a.layout.y - b.layout.y) || (a.layout.x - b.layout.x));
    const placedRects = [];

    return sorted.map((widget) => {
        const w = widget.layout.w;
        const h = widget.layout.h;
        const x = Math.max(0, Math.min(cols - w, widget.layout.x));
        let y = 0;
        while (hasCollision(placedRects, { x, y, w, h })) {
            y += 1;
        }
        placedRects.push({ x, y, w, h });
        return { ...widget, layout: { ...widget.layout, x, y } };
    });
}

export function gridCellSize(containerWidth, cols, marginX) {
    const colWidth = Math.max(1, (containerWidth - marginX * (cols - 1)) / cols);
    return colWidth;
}
